import "./SectionHeading.css";

/**
 * Consistent heading for every section: a plain word, a pink accented word
 * with the blue brush underline, and an optional sub-line.
 *
 *   <SectionHeading plain="Our" accent="Gallery" />
 */
export default function SectionHeading({ plain, accent, as: Tag = "h2", children }) {
  return (
    <header className="section-heading">
      <Tag>
        {plain}{" "}
        <span className="section-heading__accent">
          {accent}
          <img src="/images/strike.png" alt="" />
        </span>
      </Tag>
      {children && <p>{children}</p>}
    </header>
  );
}
